import React from 'react';
import { Users, MapPin, Award, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { impactData } from '../data/mock';

const iconMap = { Users, MapPin, Award, CheckCircle };

const Impact = () => {
  return (
    <section id="impact" className="py-24 relative overflow-hidden" data-testid="impact-section">
      <div className="absolute inset-0 z-0">
        <img src={impactData.image} alt="Notre Impact" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-navy/90" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-16">
          <p className="uppercase text-xs md:text-sm tracking-[0.2em] font-bold text-forest mb-4 font-sans">
            Impact & Resultats
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white mb-4 tracking-tight">
            {impactData.title}
          </h2>
          <div className="w-16 h-1 bg-forest rounded-full mb-6" />
          <p className="text-lg text-white/70 font-sans">{impactData.subtitle}</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {impactData.stats.map((stat, index) => {
            const Icon = iconMap[stat.icon];
            return (
              <motion.div
                key={stat.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-center border border-white/10 hover:bg-white/15 transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-full bg-forest/20 flex items-center justify-center mx-auto mb-5">
                  <Icon className="w-7 h-7 text-forest" />
                </div>
                <div className="text-4xl md:text-5xl font-serif font-bold text-white mb-2">
                  {stat.number}
                </div>
                <div className="text-sm text-white/70 font-sans font-medium">
                  {stat.label}
                </div>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-16 text-center"
        >
          <p className="text-xl text-white/60 italic font-serif max-w-3xl mx-auto">
            "Chaque femme autonomisee est une graine de paix plantee dans notre communaute"
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Impact;
